import {
  AGENT_BY_PROFIL,
  GENERATE_CODE_LIVRAISON,
  VERFIF_PAIEMENT,
} from "../Utils/constant";
import clientAxios from "./axios";

export const getAll = async (url, params, otherParam) => {
  return await clientAxios.get(
    `${url}?page=${params.page}&param=${params.param}&size=${params.size}${otherParam}`
  );
};

export const getAgentByProfile = async (profile) => {
  return await clientAxios.get(`${AGENT_BY_PROFIL}?profil=${profile}`);
};

export const getOne = async (url, id) => {
  return await clientAxios.get(`${url}?numeroTicket=${id}`);
};

export const getStatCounter = async (url, filterData) => {
  return await clientAxios.get(
    `${url}?periode=${filterData.periode}&mois=${filterData.mois}&annee=${filterData.annee}&dateDebut=${filterData.dateDebut}&dateFin=${filterData.dateFin}`
  );
};

export const getStat = async (url, contentType, ...filterData) => {
  return await clientAxios.post(`${url}`, ...filterData, {
    headers: { "Content-Type": contentType },
  });
};

export const findOne = async (url, id) => {
  return await clientAxios.get(`${url}/${id}`);
};
export const verifyPaiement = async (ref) => {
  return await clientAxios.get(`${VERFIF_PAIEMENT}?reference=${ref}`);
};

export const generateCode = async (ticket) => {
  return await clientAxios.get(
    `${GENERATE_CODE_LIVRAISON}?numeroTicket=${ticket}`
  );
};

export const store = async (url, contentType, ...data) => {
  return await clientAxios.post(`${url}`, ...data, {
    headers: { "Content-Type": contentType },
  });
};

export const add = async (url, contentType, ...data) => {
  return await clientAxios.post(`${url}`, ...data, {
    headers: { "Content-Type": contentType },
  });
};

export const updateOne = (url, id, ...data) => {
  return clientAxios.post(`${url}/${id}`, ...data);
};

export const disable = async (url, userId) => {
  return await clientAxios.post(`${url}/${userId}`, {});
};

export const deleteOne = async (url, userId) => {
  return await clientAxios.delete(`${url}/${userId}`);
};

export const find = async (url) => {
  return await clientAxios.get(`${url}`);
};
